import StripeContainer from '../../Stripe/StripeContainer';

const Payment = () => {
    return (
        <div className='payment-container'>
           <StripeContainer />
        </div>
    );
}

export default Payment;